// ...existing code...
import React from "react";
import "./careers.css";

const Careers = () => {
  return (
    <section className="careers-section" id="careers" aria-labelledby="careers-title">
      <div className="careers-inner">
        <header className="careers-header">
          <h2>
          Careers 
        </h2>
          <h1 id="careers-title">Employee focus is not a myth at Lyros</h1>
          <p className="lead">
            We believe that each employee has intrinsic worth and deserve our greatest respect and support.
            We foster a culture that is true to our core values, and intended to promote employee satisfaction.
          </p>
        </header>

        <div className="careers-grid">
          <article className="card values-card" aria-labelledby="values-title">
            <h2 id="values-title">Our Core Values</h2>
            <ul className="values-list">
              <li><strong>Honesty and Integrity</strong> — Always doing the right thing, and treating all with honesty and openness.</li>
              <li><strong>Respect</strong> — Honoring the worth of each individual, both in and out of the company.</li>
              <li><strong>Fairness</strong> — Ensuring that fairness is at the basis of our actions and our relationships.</li>
              <li><strong>Trust</strong> — Having full confidence in employees’ abilities and commitment to the company.</li>
              <li><strong>Candor</strong> — Being direct and positive in communication with others.</li>
              <li><strong>Collaboration</strong> — Encouraging teamwork.</li>
              <li><strong>Empowerment</strong> — Enabling employees to make decisions, take initiative, &amp; act.</li>
              <li><strong>Ownership</strong> — Taking responsibility for making Lyros a great company.</li>
              <li><strong>Customer Satisfaction</strong> — Always putting the customer (both internal and external) point of view as priority number one.</li>
            </ul>
          </article>

          <article className="card env-card" aria-labelledby="env-title">
            <h2 id="env-title">Our Work Environment Includes</h2>
            <ul className="env-list">
              <li>Open and regular communication among all parties.</li>
              <li>Diversity that is valued and embraced.</li>
              <li>Opinions that count and recognition for contributions.</li>
              <li>Managers who care about everyone’s success.</li>
              <li>Balance between work and personal life.</li>
              <li>Regular opportunities to learn and grow.</li>
              <li>Materials and equipment to do the job right.</li>
              <li>Ability and authority to satisfy customers.</li>
              <li>Innovation and creativity supported at all levels.</li>
              <li>Quality and continuous improvement emphasized in all we do.</li>
            </ul>
          </article>
        </div>

        <div className="careers-footer card">
          <p>
            Our over-riding goal is to build a company known for a strong blend of employee focus and customer service orientation,
            accompanied by operational excellence. This is a company that will lead and last, one that we all can be proud of.
          </p>

          <div className="cta-row">
            <p className="cta-text">Mail your resumes at</p>
            <p className="cta-mail" >hr@lyrostech.com</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Careers;
// ...existing code...